import { TableCell } from '@mui/material'
import styled from 'styled-components'
import { fontWeightThin } from 'Utils/styles/text'
import { black, Colors } from 'Utils/styles/colors'

export const StyledTableCell = styled(TableCell)<{ color?: Colors }>`
  font-weight: ${fontWeightThin} !important;
  color: ${({ color }) => color ?? black} !important;
`
